import * as React from "react";
import { WithStyles, withStyles } from "@material-ui/styles";
import { Box, Typography, TextField, Button } from "@material-ui/core";
import { FormattedMessage, useIntl } from "react-intl";
import { isIE } from "react-device-detect";
import messages from "../constants/messages";

import { styles } from "../constants/styles";
import { PasswordExpFormProps } from "../constants/types";
import cn from "classnames";
import { useAdministration } from "../../../modules/admin";

type Props = PasswordExpFormProps & WithStyles<typeof styles>;

const PasswordExpForm: React.FC<Props> = (props: Props) => {
  const { classes, passwordExpire } = props;

  const intl = useIntl();
  const [, , , , , , setExpirationPeriod] = useAdministration();
  const [formState, setFormState] = React.useState({ "requiredField": `${passwordExpire}`, "error": false, "showErrorMessage": false });


  const handleChangeText = () => (event: any) => {
    const re_dot = new RegExp(/[.]+/g);
    if( event.target.value < 13 && !re_dot.test(event.target.value)){
      setFormState({
        ...formState,
        requiredField: event.target.value.trim(),
        error: formState.error,
      });
    }
  };

  const handleApply = () => {
    const isValid = checkValidity();
    const { handleCancel } = props;

    if (isValid) {
    const period = formState.requiredField;
    setExpirationPeriod(period)
    handleCancel();
    }
    setFormState({...formState, requiredField: "", showErrorMessage: true });
  };

    const checkValidity = () => {
      const period = formState.requiredField;
      return Number(period) && (Number(period) > 0) && (Number(period) <= 12) && Number(period) % 1 === 0;
    };

  const renderHelperText = () => {
    return (
      formState.showErrorMessage && <FormattedMessage {...messages.responseErrorPeriodIncorrect} />
    );
  };

  return (
    <Box className={classes.modalBox}>
      <Typography className={classes.modalHeader}>
        <FormattedMessage {...messages.passExpPeriodFormHeader} />
      </Typography>
      <div className={classes.fieldItem}>
        <TextField
          className={classes.fieldContent}
          type={"text"}
          variant="outlined"
          fullWidth
          value={formState.requiredField}
          InputLabelProps={{ classes: { root: classes.modalInputLabel }, shrink: isIE ? true : undefined }}
          onChange={handleChangeText()}
          helperText={renderHelperText()}
          FormHelperTextProps={{ classes: { root: classes.helperText } }}
          classes={{ root: classes.textField }}
          placeholder={intl.formatMessage(messages.passExpPeriodFormHelper)}
          inputProps={{ maxLength: 2 }}
        ></TextField>
      </div>
      <div className={classes.modalButtonBase}>
        <Button className={classes.modalButtons} variant="contained" color="primary" onClick={handleApply}>
          <FormattedMessage {...messages.saveButton} />
        </Button>
        <Button className={classes.btnCancel} variant="contained" onClick={props.handleCancel}>
          <FormattedMessage {...messages.cancelButton} />
        </Button>
      </div>
    </Box>
  );
};

export default withStyles(styles)(PasswordExpForm);
